<template>
  <div
    class="basic-progress"
    :class="{ 'basic-progress--colored': $props.colored }"
  >
    <div class="basic-progress__title">
      <div
        class="h3"
        v-text="titleLabel"
      />
    </div>
    <div class="basic-progress__bar">
      <div
        class="basic-progress__progress"
        :class="{ 'basic-progress__progress--empty': progress === 0 }"
        :style="{ width: 100 - progress + '%' }"
      />
    </div>
  </div>
</template>

<script setup>
/**
 * FIGMA:
 * - https://www.figma.com/design/2Lv13Q07rWzbxX158IrlgU/%F0%9F%93%90-EP-DVP-Master?node-id=7585-48773&m=dev
 * - https://www.figma.com/design/2Lv13Q07rWzbxX158IrlgU/%F0%9F%93%90-EP-DVP-Master?node-id=13269-104140&m=dev
 */
// INIT
  defineProps({
    colored: {
      type: Boolean,
      default: false,
    },

    titleLabel: {
      type: String,
      default: null,
    },

    progress: {
      type: Number,
      default: 0,
    },
  })
</script>

<style scoped>
.basic-progress {
  .basic-progress__title {
    text-align: center;
    padding-bottom: var(--dotcom-responsive-spacing-res-xxs);
  }

  .basic-progress__bar {
    position: relative;
    width: 100%;
    height: var(--fixed-spacing-fix-03);
    border: none;
    border-radius: var(--radius-border-radius-full);
    background: var(--tertiary);
  }

  &.basic-progress--colored .basic-progress__bar {
    background: linear-gradient(
      90deg,
      rgba(247, 142, 30, 1) 0%,
      rgba(255, 192, 34, 1) 18%,
      rgba(255, 227, 56, 1) 32%,
      rgba(244, 252, 60, 1) 40%,
      rgba(234, 233, 79, 1) 45%,
      rgba(189, 241, 127, 1) 52%,
      rgba(134, 229, 153, 1) 59%,
      rgba(96, 198, 135, 1) 68%,
      rgba(1, 114, 87, 1) 81%,
      rgba(11, 79, 63, 1) 100%
    );
  }

  .basic-progress__progress {
    transition: all 0.3s ease-in-out;
    position: absolute;
    right: 0;
    height: 100%;
    border-top-right-radius: var(--fixed-border-radius-fix-full);
    border-bottom-right-radius: var(--fixed-border-radius-fix-full);
    background-color: var(--surface-dim);

    &--empty {
      border-top-left-radius: var(--fixed-border-radius-fix-full);
      border-bottom-left-radius: var(--fixed-border-radius-fix-full);
    }
  }
}
</style>
